import React from 'react'
import Appbar from './Appbar'
import Sidebar from './Sidebar'
import { Button, Grid, OutlinedInput, Paper } from '@mui/material';
import "../Assets/CSS/BnbConnect.css"
import { useNavigate } from 'react-router-dom';



const Withdrawal = () => {
        const [mobileOpen, setMobileOpen] = React.useState(false);
    const navigate = useNavigate();
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

  return (
    <div className='bnbcontainer'>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <Appbar handleDrawerToggle={handleDrawerToggle} />
                </Grid>

                <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                        <Grid item md={2}>
                            <Sidebar open={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                        </Grid>
                        <Grid item xs={12} md={10} sx={{ mt: "70px" }}>
                            <Grid container spacing={3} p={3}>
                                <Grid item xs={12} md={12}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", padding: "15px", borderRadius: "10px" }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <div className='headerconn'>
                                                    <div className='dashbheading'
                                                    onClick={()=>{
                                                        navigate("/dashboard")
                                                    }}
                                                    >Dashboard</div>
                                                    <div className='subheading'>
                                                        / Withdrawal
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>

                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white",borderRadius:"20px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={12} >
                                                <div className='topuptitle'>Withdrawal</div>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <hr />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Grid container spacing={2} sx={{paddingLeft:"30px",paddingRight:"30px",paddingBottom:"30px"}}>
                                             <Grid item xs={12} md={12}>
                                                 <div className='title'>
                                                    Wallet Balance
                                                </div>
                                                <OutlinedInput
                                                    placeholder="0.0000000 BNB"
                                                    className="whiteInput"
                                                    id="outlined-adornment-amount"
                                                    fullWidth
                                                    size='small' />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Button variant="contained"
                                                    sx={{
                                                        border: "none",
                                                        color: "#fff",
                                                        fontSize: "16px",
                                                        borderRadius:"10px"
                                                    }}
                                                    className='copybtn'
                                                >Submit</Button>
                                            </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>
            </Grid>
        </div>
  )
}

export default Withdrawal